class Auth {
  static getAll(userStatus, companyId) {
    // console.log({userStatus, companyId})
    if (!userStatus) return {};
    return {
      isDeveloper: this.isDeveloper(userStatus),
      isMainAdmin: this.isMainAdmin(userStatus),
      isAdmin: this.isAdmin(userStatus, companyId),
      isSubAdmin: this.isSubAdmin(userStatus, companyId),
      isUser: this.isUser(userStatus, companyId)
    };
  }
  static isDeveloper(userStatus) {
    return userStatus === "developer";
  }
  static isMainAdmin(userStatus) {
    return this.isDeveloper(userStatus) || userStatus?.includes("mainAdmin");
  }
  static isAdmin(userStatus, companyId) {
    // console.log({userStatus, companyId})
    return this.isMainAdmin(userStatus) || (userStatus?.includes(`#${companyId}|`) && userStatus?.includes("admin"));
  }
  static isSubAdmin(userStatus, companyId) {
    return this.isAdmin(userStatus, companyId) || (userStatus?.includes(`#${companyId}|`) && userStatus?.includes("subAdmin"));
  }
  static isUser(userStatus, companyId) {
    return this.isSubAdmin(userStatus, companyId) || userStatus?.includes("user");
  }
  static isCorrectCompany(currentUser, companyId) {
    const idStr = currentUser.userStatus.split("#")[1]?.split("|")[0];
    const userCompanyId = idStr ? parseInt(idStr) : 0;
    console.log({userCompanyId, companyId});
    return userCompanyId === companyId;
  }

  static getCompareAll(currentUser, otherUser) {
    const currentUserStatus = currentUser?.userStatus;
    const otherUserStatus = otherUser?.userStatus;
    return {
      cuHasHigherStatus: this.cuHasHigherStatus(currentUserStatus, otherUserStatus),
      sameStatus: currentUserStatus === otherUserStatus,
      mayEdit: this.mayEdit(currentUser, otherUser),
      mayInvite: this.mayInvite(currentUser, otherUser),
      isSameUser: currentUser.username === otherUser.username
    };
  }
  static sameUser(currentUser, otherUser) {
    return currentUser.username === otherUser.username;
  }
  static sameStatus(currentUserStatus, otherUserStatus) {
    return currentUserStatus === otherUserStatus;
  }
  static cuHasHigherStatus(currentUserStatus, otherUserStatus) {
    if (this.isDeveloper(currentUserStatus)) return true;
    if (this.isMainAdmin(currentUserStatus) && !this.isMainAdmin(otherUserStatus)) return true;
    if (currentUserStatus.split("|")[0] !== otherUserStatus.split("|")[0]) return false;
    const arr = ["developer", "mainAdmin", "admin", "subAdmin", "user"];
    console.log(
      arr.findIndex(i => currentUserStatus.includes(i)),
      arr.findIndex(i => otherUserStatus.includes(i))
    );
    if (arr.findIndex(i => currentUserStatus.includes(i)) < arr.findIndex(i => otherUserStatus.includes(i))) return true;

    return false;
  }
  static mayEdit(currentUser, otherUser) {
    return this.cuHasHigherStatus(currentUser.userStatus, otherUser.userStatus) || this.sameUser(currentUser, otherUser);
  }
  static mayInvite(currentUser, otherUser) {
    return (
      !this.sameUser(currentUser, otherUser) &&
      (this.cuHasHigherStatus(currentUser.userStatus, otherUser.userStatus) ||
        this.sameStatus(currentUser.userStatus, otherUser.userStatus))
    );
  }
}
module.exports = Auth;
